import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

// components
import {CarFormComponent} from "../car-form/car-form.component";

// services
import {CarsService} from "../../../shared/services/cars.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {Car} from "../../../shared/models/cars/car";
import {ApiMessage} from "../../../shared/models/api-message";

@Component({
    selector: 'app-car-update',
    templateUrl: './car-update.component.html',
    styleUrl: './car-update.component.scss'
})
export class CarUpdateComponent implements OnInit {

    @ViewChild('data') data!: CarFormComponent;

    public isLoading = false;
    public carID = 0;
    public car!: Car;

    constructor(private carsService: CarsService,
                private snackbarService: SnackbarService,
                private route: ActivatedRoute,
                private router: Router) {
    }

    ngOnInit(): void {
        this.carID = Number(this.route.snapshot.paramMap.get('id'));
        this.getCarData(this.carID);
    }

    public closeForm(): void {
        this.router.navigateByUrl(`secure/car-show/${this.carID}`).then();
    }

    public updateCar(): void {
        this.carsService.updateCar(this.carID, this.data.carForm.getRawValue()).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => this.closeForm()
        })
    }

    private getCarData(id: number): void {
        this.isLoading = true;
        this.carsService.getCar(id).subscribe((car: Car): void => {
            this.car = car;
            this.isLoading = false;
        })
    }
}
